$(document).ready(function () {
    //- Set current Year to footer Copyright
    if($('#year').length) {
        let thisDate = new Date();
        $('#year').html(thisDate.getFullYear());
    }
});
